module.exports = __webpack_public_path__ + "2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2";